<template>
    <div class="container">
        <div class="vue-klantenvertellen-vestiging klantenvertellen-block-large row flex-column-reverse flex-md-row-reverse">
            <div class="content-wrapper dark-theme col-12 col-md-7 no-gutters">
                <div class="inner" v-if="hasRating">
                    <h2>
                        <span class="color-main">Onze klanten</span><br>
                        beoordelen ons met een
                    </h2>

                    <div class="rating-wrapper">
                        <div class="grade">
                            <a :href="viewLink" target="_blank">
                                {{ score }}
                            </a>
                        </div>

                        <div class="rating" :style="`--rating: ${stars}`">
                            <div class="rating-upper" :style="{ width: percentage }"></div>
                            <p>Gebaseerd op {{ numberOfReviews }} reviews</p>
                        </div>

                        <a :href="writeLink" target="_blank" class="cta-link">Schrijf ook een review</a>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-5">
                <div class="image-wrapper">
                    <div class="image"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {klantenvertellenOptions} from "../mixins/klantenvertellen";

export default {
    name: "ReviewBlockVestiging",

    mixins: [klantenvertellenOptions],

    methods: {
        shouldPopulateCookie() {
            return false;
        }
    }
}
</script>
